import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReportHeader from "../../../../Components/ReportHeader";
import { useGenerateReportMutation } from "../../../../features/Report/reportSlice";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Papa from 'papaparse';
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js'; // Import html2pdf.js
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { utils, writeFile } from "xlsx";



const SubReport6 = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const year = queryParams.get("year")
    const ReportType = queryParams.get("reportType")
    const GrpID = queryParams.get("groupId")
    const rows = Array(7).fill();
    const rowsCs = Array(5).fill();
    const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();

    console.log("REPORT", reportData)




    useEffect(() => {
        const handleReportGeneration = async () => {
            try {
                await generateReport({
                    year,
                    reportType: ReportType,
                    groupId: GrpID,
                }).unwrap();
            } catch (err) {
                console.error("Error generating report:", err);
            }
        };
        handleReportGeneration();
    }, [year, ReportType, GrpID, generateReport]);

    if (reportLoading) return <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: "20px" }}>Loading...</div>;
    if (error) return <div style={{ height: "100vh", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
    </div>;



    const generatePDF = () => {
        const doc = new jsPDF();

        const addHeader = (doc) => {
            doc.setFontSize(16);
            doc.setTextColor(40);

            // First title
            doc.text("Report6 Direct By Years", 14, 10);

            doc.setLineWidth(0.5);
        };

        // Call the header function for the first page
        addHeader(doc);

        let startY = 26;


        const tableColumnHeaders = ["Company Name", ...years];

        const tableRows = [];

        // Add title row spanning all columns
        tableRows.push([
            {
                content: "No. of Vendors that Received Direct Spend",
                colSpan: tableColumnHeaders.length,
                styles: { halign: "center", fontStyle: "bold", fontSize: 14, fillColor: [255, 255, 255] },
            }
        ]);

        // Add headers row
        tableRows.push(tableColumnHeaders);

        // Add data rows
        allCompanies.forEach((companyName) => {
            tableRows.push([
                companyName,
                ...years.map((year) => {
                    const yearData = reportData?.data?.reportData?.find((item) => item.year === year);
                    const companyData = yearData?.companies.find((comp) => comp.CompanyName === companyName);
                    return companyData ? companyData.Suppliers : "";
                }),
            ]);
        });

        // Add total suppliers row
        const totalSuppliersRow = [
            {
                content: "Total Suppliers",
                styles: { fontStyle: "bold", halign: "left" },
            },
            ...reportData?.data?.reportData?.map((itm) => itm?.TotalSuppliers || ""),
        ];
        tableRows.push(totalSuppliersRow);

        doc.autoTable({
            startY: startY,
            body: tableRows,
            showHead: "firstPage",
            styles: {
                fontSize: 7,
                cellPadding: 4,
            },
            headStyles: {
                fillColor: [233, 248, 255], // Light blue background
                textColor: "#000",
                fontStyle: "bold",
            },
            bodyStyles: {
                textColor: "#1A1A1A",
            },
        });

        doc.save("report.pdf");
    };

    const generateCSV = () => {
        const tableHeaders = [
            'Company Name',
            ...years.map(year => `${year}`)
        ];

        const tableData = allCompanies.map(companyName => {
            const row = [companyName];
            years.forEach(year => {
                const yearData = reportData?.data?.reportData?.find(item => item.year === year);
                const companyData = yearData?.companies.find(comp => comp.CompanyName === companyName);
                row.push(companyData ? companyData.Suppliers : '');
            });
            return row;
        });

        const totalRow = ['Total'];
        reportData?.data?.reportData.forEach(itm => {
            totalRow.push(itm?.TotalSuppliers);
        });
        tableData.push(totalRow);

        // Convert to CSV string
        let csvContent = 'Report6 Direct By Years\n';  // Add title at the start
        csvContent += 'No. of Vendors that Received Direct Spend' + '\n';
        csvContent += `${tableHeaders.join(',')}\n`;  // Adding headers

        tableData.forEach(row => {
            csvContent += `${row.join(',')}\n`;
        });

        // Trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'report.csv';
        link.click();
    };


    const generateXLSX = () => {
        // Table headers
        const tableHeaders = [
            'Company Name',
            ...years.map(year => `${year}`)
        ];

        // Table data
        const tableData = allCompanies.map(companyName => {
            const row = [companyName];
            years.forEach(year => {
                const yearData = reportData?.data?.reportData?.find(item => item.year === year);
                const companyData = yearData?.companies.find(comp => comp.CompanyName === companyName);
                row.push(companyData ? companyData.Suppliers : '');
            });
            return row;
        });

        // Add total row
        const totalRow = ['Total'];
        reportData?.data?.reportData.forEach(itm => {
            totalRow.push(itm?.TotalSuppliers);
        });
        tableData.push(totalRow);

        // Create the worksheet
        const ws = XLSX.utils.aoa_to_sheet([['Report6 Direct By Years'], [], ["No. of Vendors that Received Direct Spend"], tableHeaders, ...tableData]);

        // Create the workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Report');

        // Generate and download the XLSX file
        XLSX.writeFile(wb, 'report.xlsx');
    };

    // Call this function when you want to generate the CSV
    //   generateCSV();


    const downloadHandle = (val) => {
        console.log("VL", val)
        if (val === 1) {
            generatePDF()
        }
        if (val === 2) {
            generateXLSX()
        }
        if (val === 3) {
            generateCSV()
        }

    }



    const handleTitle = () => {

        return ""
    }

    // Extract unique years for table headers
    const years = reportData?.data?.reportData.map(item => item.year);

    // Collect all unique company names
    const allCompanies = Array.from(new Set(reportData?.data?.reportData.flatMap(item => item.companies.map(company => company.CompanyName))));



    return (
        <div id="report_generation">
            <ReportHeader handleClick={reportData?.data?.reportData?.length < 1 ? () => { } : downloadHandle} title={handleTitle()} year={year} report={ReportType} logo={reportData?.data?.logo} />
            {reportData?.data?.reportData?.length < 1 ?
                <div style={{ height: "calc(100vh - 225px)", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
                </div>
                :
                <div style={{ height: "calc(100vh - 225px)", overflow: 'auto' }} id="modal_body">
                    <TableContainer component={Paper} sx={{ marginTop: "0px" }}>
                        {/* {console.log(data, "data")} */}
                        <Table aria-label='customized table'>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align='center'
                                        colSpan={years?.length + 1}
                                        style={{
                                            background: "#fff",
                                            fontWeight: "700",
                                            color: "#000000",
                                            fontSize: "16px",
                                            textAlign: "center",
                                            borderRight: "1px solid #E6E6E6",
                                            whiteSpace: "nowrap",
                                            letterSpacing: "0.2px"
                                        }}>
                                        No. of Vendors that Received Direct Spend
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        align='center'
                                        style={{
                                            background: "#fff",
                                            fontWeight: "700",
                                            color: "#000000",
                                            fontSize: "16px",
                                            textAlign: "center",
                                            borderRight: "1px solid #E6E6E6",
                                            whiteSpace: "nowrap",
                                            letterSpacing: "0.2px",
                                            width: "180px"
                                        }}>
                                        {`Company Name`}
                                    </TableCell>
                                    {years?.map((header, id) => (
                                        <TableCell
                                            key={id}
                                            align='center'
                                            style={{
                                                background: "#E9F8FF",
                                                fontWeight: "700",
                                                color: "#000000",
                                                fontSize: "16px",
                                                textAlign: "center",
                                                borderRight: "1px solid #E6E6E6",
                                                whiteSpace: "",
                                                letterSpacing: "0.2px"
                                            }}>
                                            {`${header}`}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    allCompanies.map((companyName, rowIndex) => (
                                        <TableRow key={rowIndex} sx={{ height: "40px" }}>
                                            <TableCell sx={{textAlign:"center"}}>{companyName}</TableCell>
                                            {years.map((year, colIndex) => {
                                                // Find supplier count for the company in the given year
                                                const yearData = reportData?.data?.reportData?.find(item => item.year === year);
                                                const companyData = yearData?.companies.find(comp => comp.CompanyName === companyName);
                                                return <TableCell sx={{ textAlign: "center", border: "1px solid #E6E6E6" }} key={colIndex}>{companyData ? companyData.Suppliers : ""}</TableCell>;
                                            })}
                                        </TableRow>
                                    ))
                                }
                                <TableRow sx={{ height: "40px" }}>
                                    <TableCell>{""}</TableCell>
                                    {
                                        reportData?.data?.reportData?.map((itm, ix) => {
                                            return (
                                                <TableCell sx={{ fontWeight: "700", textAlign: "center" }}>
                                                    {itm?.TotalSuppliers}
                                                </TableCell>
                                            )
                                        })
                                    }
                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            }
        </div>
    )
}

export default SubReport6